import { render, staticRenderFns } from "./posDiscount.vue?vue&type=template&id=01eb3fa7"
import script from "./posDiscount.vue?vue&type=script&lang=js"
export * from "./posDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports